import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// 币商列表页 (http://wiki.xunlei.cn/pages/viewpage.action?pageId=164421646)
export const ra_page = createAsyncThunk(
  'Saada/live/hiya_socialize/ra_page',
  async (p: any, store: any) => {
    const resp = await http.post('/live/hiya_socialize/ra_page', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export interface InitialStateType {
  listPage?: {
    coins?: number
    show_tips?: boolean
  }
}

const initialState: InitialStateType = {}

export const SaadaAgencySlice = createSlice({
  name: 'Animal_Orca',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(ra_page.fulfilled, (state, action) => {
      Object.assign(state, {listPage: action.payload.data})
    })
  },
})

export default SaadaAgencySlice.reducer

export const useSaadaAgencyState = () => {
  const data = useSelector((state) => {
    return state.Animal_Orca
  })
  return data
}
